import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../Assets/Css/home.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import securityImg from "../Assets/Images/security.avif";
import hospitalityImg from "../Assets/Images/manpower.avif";
import constructionImg from "../Assets/Images/constructionworker.avif";
import maintenanceImg from "../Assets/Images/RoutineMaintenance.jpg";
import steelImg from "../Assets/Images/samshree_fabrication1.jpg";
import marklineimg from "../Assets/Images/markline.avif";
import aboutimg from "../Assets/Images/aboutimage.png";
import ctaimg from "../Assets/Images/ctaimge.png";
import { FaTools, FaBroom, FaClipboardList } from "react-icons/fa";
import { Helmet } from "react-helmet";
import mottoimage from "../Assets/Images/samashreeenterprises.png";

// our client images import
import client1 from "../Assets/Images/samashree-client1.png";
import client2 from "../Assets/Images/samashree-client2.png";
import client3 from "../Assets/Images/samashree-client3.png";
import client4 from "../Assets/Images/samashree-client4.png";
export default function HomePage() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  const servicesData = [
    { title: "Fabrication & Erection", img: steelImg },
    { title: "Security & Housekeeping", img: securityImg },
    { title: "Manpower Services", img: hospitalityImg },
    { title: "Mark Line Services", img: marklineimg },
    { title: "Civil Construction", img: constructionImg },
    { title: "Routine Maintenance", img: maintenanceImg },
  ];
  const testimonials = [
    {
      message:
        "Samashree Enterprises has provided exceptional security services for our plant. Highly professional and reliable!",
      author: "Factory Manager",
    },
    {
      message:
        "Their hospitality staff is well-trained and courteous. A pleasure working with the team.",
      author: "Hotel Owner",
    },
    {
      message:
        "Outstanding housekeeping services and very prompt response times. Truly dependable!",
      author: "Facility Supervisor",
    },
    {
      message:
        "Top-notch service! The staff is respectful and always on time. Highly recommended.",
      author: "Corporate Admin",
    },
  ];
  return (
    <>
      <div className="mainnav min-vh-100">
        <Helmet>
          <title>
            SAMASHREE ENTERPRISES PVT. LTD. | Trusted Civil & Fabrication
            Experts
          </title>
          <meta
            name="description"
            content="Over 20 years of expertise in fabrication, erection, civil construction, manpower, and maintenance services across India."
          />
          <meta
            name="keywords"
            content="fabrication, civil construction, manpower, security, housekeeping, India"
          />
          <meta name="author" content="SAMASHREE ENTERPRISES PVT. LTD." />
        </Helmet>

        {/* Hero Section */}
        <section className="hero-section">
          <div className="overlay" data-aos="zoom-in">
            <h1>
              <span className="fw-bold hometitle" style={{ color: "#FE8200" }}>
                {" "}
                SAMASHREE
              </span>
              <span className="fw-bold hometitle" style={{ color: "white" }}>
                {" "}
                ENTERPRISES
              </span>{" "}
              <br />
              <span className="fw-bold hometitle" style={{ color: "#35b3b3" }}>
                {" "}
                PRIVATE LIMITED{" "}
              </span>
            </h1>
            <p style={{ color: "white", fontFamily: "Pacifico, cursive" }}>
              Committed @ Your Service
            </p>
            <a href="/contact" className="btn-get ">
              {" "}
              Get in Touch{" "}
            </a>
          </div>
        </section>

        {/* About Section */}
        <section className="about-preview py-5">
          <Container>
            <Row className="align-items-center">
              {/* Text Section */}
              <Col md={6}>
                <h2 className="page-title" data-aos="fade-up">
                  {" "}
                  About Us{" "}
                </h2>
                <div
                  style={{ textAlign: "justify" }}
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <p>
                    In today’s world, perfection may be rare, but it is
                    unmistakable when achieved. This is what
                    <span className="fw-bold" style={{ color: "#FE8200" }}>
                      {" "}
                      SAMASHREE
                    </span>
                    <span className="fw-bold" style={{ color: "#008080" }}>
                      {" "}
                      ENTERPRISES
                    </span>
                    <span className="fw-bold" style={{ color: "#28326E" }}>
                      {" "}
                      PRIVATE LIMITED{" "}
                    </span>
                    proudly represents.
                  </p>
                  <p>
                    we pride ourselves on delivering that perfection across
                    fabrication, erection, civil construction, manpower
                    services, and maintenance. With over 10 years of industry
                    experience, we have consistently met and exceeded the
                    expectations of clients through our commitment to quality,
                    safety, and professional excellence.
                  </p>
                </div>
                <a href="/about" className="btn-learn mb-4" data-aos="zoom-in">
                  {" "}
                  Learn More{" "}
                </a>
              </Col>

              {/* Image Section */}
              <Col md={6}>
                <div className="d-flex justify-content-center">
                  <img
                    src={aboutimg}
                    alt="Teamwork and Services"
                    className="img-fluid aboutimg rounded shadow"
                    data-aos="zoom-in"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <Container className="py-5">
          <Row className="justify-content-center">
            <Col md={10}>
              <div className="who-we-are-section p-5 rounded ">
                <h2 className="page-title" data-aos="fade-up">
                  {" "}
                  Who We Are{" "}
                </h2>
                <p className="text-center  text-dark">
                  We are a trusted name in infrastructure development and
                  service solutions. From industrial fabrication and erection to
                  civil construction, security, housekeeping, and manpower
                  solutions,<b> Samashree Enterprises </b> ensures reliable
                  delivery with skilled expertise and modern machinery.
                </p>
                <h5 className="mt-4 fw-semibold"> We specialize in: </h5>
                <ul className="custom-list1 mt-3">
                  <li>
                    <FaTools className="whoicon me-3 text-primary" />
                    Fabrication and erection of industrial sheds, foot over
                    bridges, NH/SH road gantries, and more.
                  </li>
                  <li>
                    <FaBroom className="whoicon me-3 text-success" />
                    Providing routine maintenance, manpower services, security
                    and housekeeping, and mark line services.
                  </li>
                  <li>
                    <FaClipboardList className="whoicon me-3 text-warning" />
                    Following strict compliance with industry and government
                    standards supported by our experienced team.
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>

        <section className=" motto-section py-5 ">
          <Container>
            <Row className="justify-content-center align-items-center">
              <Col lg={5} md={6} sm={12} className="text-center mb-4 mb-lg-0">
                <img
                  src={mottoimage}
                  alt="Our Motto Visual"
                  className="img-fluid motto-image"
                />
              </Col>
              <Col lg={7} md={12}>
                <h2 className=" page-title " data-aos=" fade-up ">
                  Our Motto
                </h2>
                <p className=" fst-italic ">
                  Our Moto is to become a leader in integrated Project
                  Management in the field of construction and allied services
                  with a high growth trajectory and increase its market share.
                </p>
                <blockquote className=" blockquote mt-4 ">
                  <p>
                    We understand the business the way our father of nation –{" "}
                    <strong>Mahatma Gandhi</strong>
                    <br />
                    “A customer is the most important visitor on our premises.
                    <br />
                    He is not dependent on us. We are dependent on Him.
                    <br />
                    He is not an interruption to our work. He is the purpose to
                    it.”
                  </p>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Services Summary */}

        <section className=" services-summary py-4 mb-4 ">
          <Container>
            <h2 className=" page-title " data-aos=" fade-up ">
              {" "}
              Our Services{" "}
            </h2>
            <Row className="gx-3 mt-4">
              {servicesData.map((service, index) => (
                <Col
                  key={index}
                  lg={2}
                  md={4}
                  sm={6}
                  xs={12}
                  className="mb-3"
                  data-aos="flip-up"
                  data-aos-delay={index * 100 + 200}
                >
                  <Card className=" h-100 sevicecard ">
                    <Card.Img
                      variant=" top "
                      src={service.img}
                      style={{ height: "150px", objectFit: "cover" }}
                    />
                    <Card.Body className=" text-center ">
                      <h6>{service.title}</h6>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className=" cta-section text-white py-4 ">
          <Container>
            <Row className=" align-items-center ">
              <Col md={6}>
                <div
                  className=" d-flex justify-content-center "
                  data-aos=" zoom-in "
                >
                  <img
                    src={ctaimg}
                    alt=" Professional service team at work "
                    className=" img-fluid ctaimg rounded shadow mb-2 "
                  />
                </div>
              </Col>
              <Col
                md={6}
                className=" text-center text-md-start "
                data-aos=" zoom-in "
              >
                <h2>
                  {" "}
                  Looking for Reliable, Skilled & Committed Service
                  Providers?{" "}
                </h2>
                <p className=" lead ">
                  Whether you need security personnel, construction experts, or
                  facility maintenance support — Samashree Enterprises is here
                  to serve you with excellence.
                </p>
                <a
                  href="/contact"
                  className="btn-learn mt-3"
                  data-aos="fade-up"
                >
                  Get in Touch Today
                </a>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Our Client */}
        <section className="our-clients pt-5 pb-4">
          <Container>
            <h2 className="page-title text-center" data-aos="fade-up">
              Our Clients
            </h2>

            <Row className="justify-content-center align-items-center mt-2">
              <Col
                lg={3}
                md={4}
                sm={6}
                xs={6}
                className="mb-2 text-center"
                data-aos="zoom-in"
              >
                <img src={client1} alt="Client 1" className="client-logo" />
              </Col>

              <Col
                lg={3}
                md={4}
                sm={6}
                xs={6}
                className="mb-4 text-center"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <img src={client2} alt="Client 2" className="client-logo" />
              </Col>

              <Col
                lg={3}
                md={4}
                sm={6}
                xs={6}
                className="mb-4 text-center"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <img src={client3} alt="Client 3" className="client-logo" />
              </Col>

              <Col
                lg={3}
                md={4}
                sm={6}
                xs={6}
                className="mb-4 text-center"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <img src={client4} alt="Client 4" className="client-logo" />
              </Col>
            </Row>
          </Container>
        </section>
        <section className="testimonials py-5 bg-light">
          <Container>
            <h2 className="page-title text-center "> What Our Clients Say </h2>
            <Row>
              <Col md={{ span: 8, offset: 2 }}>
                <Swiper
                  modules={[Autoplay, Pagination]}
                  spaceBetween={30}
                  slidesPerView={1}
                  autoplay={{ delay: 5000 }}
                  loop={true}
                  pagination={{ clickable: true }}
                >
                  {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                      <Card className="p-4 mb-4  border-0" data-aos="zoom-in">
                        <p>⭐️⭐️⭐️⭐️⭐️</p>

                        <p className="mb-3 " style={{ fontStyle: "italic" }}>
                          “{testimonial.message}”
                        </p>

                        <small className="text-muted">
                          — {testimonial.author}
                        </small>
                      </Card>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
